

if (!customElements.get('swiper-slider')) {
  
  class SwiperSlider extends HTMLElement {

      constructor() {
          super();
          this.swiperRoot = this.querySelector('[data-swiper]');
          this.swiperPagination = this.querySelector('[data-swiper-pagination]');
          this.swiperNavigation = this.querySelector('[data-swiper-navigation]');
          this.swiperNavigationButtonPrev = this.querySelector('[data-swiper-navigation-button-prev]');
          this.swiperNavigationButtonNext = this.querySelector('[data-swiper-navigation-button-next]');
          try {
            this.data = JSON.parse(this.querySelector('script').innerText);
          } catch (error) {
            this.data = {};
          }

          this.settings = {
              direction: 'horizontal',
              centerInsufficientSlides: true,
              slidesPerView: 4,
              spaceBetween: 10,
              speed: 400,
              loop: false,
              init: false,
              pagination: {
                  el: this.swiperPagination
              },
              navigation: {
                  prevEl: this.swiperNavigationButtonPrev,
                  nextEl: this.swiperNavigationButtonNext
              },
              breakpoints: {
                  0: {
                      slidesPerView: 1
                  },
                  480: {
                      slidesPerView: 2
                  },
                  768: {
                      slidesPerView: 4
                  },
                  1440: {
                      slidesPerView: 3
                  }
              }
          }

          if (this.data && this.data.settings) {
            this.settings = { ...this.settings, ...this.data.settings };
          }

          Object.keys(this.settings.breakpoints).forEach(key => {
              key = parseFloat(key);
              if (window.innerWidth > key) {
                  this.currentBreakpoint = this.settings.breakpoints[key];
              }
          });

          if (this.data && this.data.slides) {
            this.data.slides = this.data.slides.map(slide => slide.trim());
            this.settings.virtual = {
              slides: this.data.slides
            }
          }
          this.init();
      }

      init() {

          this.swiper = new Swiper(this.swiperRoot, this.settings);
          
          if (this.productSize <= this.currentBreakpoint.slidesPerView) {
              this.swiper.params.preventClicks = false;
              this.swiper.preventClicks = false;
              this.swiper.params.preventClicksPropagation = false;
              this.swiper.preventClicksPropagation = false;
              this.swiperNavigation.setAttribute('hidden', '');
          }

          if (this.currentBreakpoint.navigation === false) {
            this.swiperNavigation.setAttribute('hidden', '');
          }

          if (this.currentBreakpoint.pagination === false) {
            this.swiperPagination.setAttribute('hidden', '');
          }

          this.swiper.init();

      }

      /**
       * 
       * Interprets the result of the search fetch and replaces all virtual skeleton loading slides of swiper
       * 
       * @param {Object} r 
       */
      /*
      parseResults(r) {
          if (r && r.results_count > 0) {
              const slides = [];
              r.results.forEach(product => {
                  const slideHtml = new DOMParser().parseFromString(product.cardHtml, 'text/html').querySelector('body').innerHTML;
                  slides.push(slideHtml);
              });
              this.swiper.virtual.slides = slides;
              if (slides.length <= this.currentBreakpoint.slidesPerView) {
                  this.swiper.params.preventClicks = false;
                  this.swiper.preventClicks = false;
                  this.swiper.params.preventClicksPropagation = false;
                  this.swiper.preventClicksPropagation = false;
                  this.swiperButtons.setAttribute('hidden', '');
              }
              this.swiper.virtual.update(true);
              if (this.hasAttribute('data-type-xsell')) {
                  this.querySelectorAll('.product-card-available-sizes').forEach(el => el.remove());
              }
          } else {
              this.closest('.shopify-section').remove();
          }
      }
      */

  }
  
  customElements.define('swiper-slider', SwiperSlider);

}
